export default __webpack_public_path__ + "./fonts/welcomeTick.c37b87ae.svg";